













import { Component, Vue, Prop } from "vue-property-decorator";
import SpinnerIcon from "@/assets/icons/SpinnerIcon.vue";

@Component({
  components: {
    appSpinnerIcon: SpinnerIcon
  }
})
export default class Button extends Vue {
  @Prop({ default: "button" }) readonly type?: string;
  @Prop({ type: String, default: "medium" }) readonly size?: string;
  @Prop({ type: Boolean, default: false }) readonly loading?: boolean;
}
